module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-row', {
    staticClass: "mb20"
  }, [_c('blockquote', {
    staticClass: "elem-quote"
  }, [_c('p', [_vm._v("这里列出常见表单项，如有不满足的，请查询Element Ui文档"), _c('a', {
    staticClass: "pl10 blue",
    attrs: {
      "target": "_blank",
      "href": "http://element.eleme.io/#/zh-CN/component"
    }
  }, [_vm._v("http://element.eleme.io/#/zh-CN/component")])])])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "text",
      "prop": "text"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "我是文本框"
    },
    model: {
      value: (_vm.form.text),
      callback: function($$v) {
        _vm.$set(_vm.form, "text", $$v)
      },
      expression: "form.text"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "select",
      "prop": "select"
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "placeholder": "我是下拉框"
    },
    model: {
      value: (_vm.form.select),
      callback: function($$v) {
        _vm.$set(_vm.form, "select", $$v)
      },
      expression: "form.select"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "2",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "remoteSelect",
      "prop": "remoteSelect"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请输入远程搜索关键字",
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.form.remoteSelect),
      callback: function($$v) {
        _vm.$set(_vm.form, "remoteSelect", $$v)
      },
      expression: "form.remoteSelect"
    }
  }, _vm._l((_vm.remoteList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "radio",
      "prop": "radio"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.radio),
      callback: function($$v) {
        _vm.$set(_vm.form, "radio", $$v)
      },
      expression: "form.radio"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("否")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "switch"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.switch),
      callback: function($$v) {
        _vm.$set(_vm.form, "switch", $$v)
      },
      expression: "form.switch"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "checkbox",
      "prop": "checkbox"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.checkbox),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkbox", $$v)
      },
      expression: "form.checkbox"
    }
  }, _vm._l((_vm.checkboxGroup), function(group) {
    return _c('el-checkbox', {
      key: group.id,
      attrs: {
        "label": group.id,
        "disabled": group.disabled
      }
    }, [_vm._v(_vm._s(group.title))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "date",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "我是日期选择"
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "upload",
      "prop": "upload"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.fileUploadAction,
      "list-type": "picture-card",
      "file-list": _vm.form.picture,
      "on-remove": _vm.handlePictureRemove,
      "on-success": _vm.handlePictureSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "batchUpload",
      "prop": "batchUpload"
    }
  }, [_c('el-upload', {
    attrs: {
      "multiple": "",
      "action": _vm.fileUploadAction,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "tree",
      "prop": "tree"
    }
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.form.tree,
      "show-checkbox": "",
      "node-key": "id",
      "default-expanded-keys": [2, 3],
      "default-checked-keys": [5]
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "tags",
      "prop": "tags"
    }
  }, _vm._l((_vm.form.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      staticClass: "mr10",
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tag.name) + "\n            ")])
  }), 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "editor",
      "prop": "editor"
    }
  }, [_c('editor', {
    on: {
      "callback": _vm.receiveContent
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "wangEditor",
      "prop": "wangEditor"
    }
  }, [_c('wang-editor', {
    on: {
      "callback": _vm.receiveWangContent
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "address",
      "prop": "address"
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.form.address.province,
      "city": _vm.form.address.city,
      "area": _vm.form.address.area
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('form')
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('form')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bb98497"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/demo/form.vue
// module id = 858
// module chunks = 0